import { useRoutes } from "react-router-dom";
import MainRoutes from "./MainRoute";

export default function ThemeRoutes() {
  return useRoutes([MainRoutes]);
}
